import React from 'react'
import { Container } from 'react-bootstrap'
import "./Card.css"

const Card = ({ title, text }) => {
    return (
        <Container fluid className='w-100 p-0'>
            <div className="card-top d-flex align-items-center"><span>{title}</span></div>
            <div className="card-bottom panel">
                <div dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        </Container>
    )
}

export default Card